import React from 'react';
import { PricingModel } from '../CRUD/CampSites/types'; // Adjust the import path as necessary
import { format, parseISO } from 'date-fns';

interface Props {
  dateRanges: { startDate: Date; endDate: Date }[];
  handleDateRangeChange: (index: number, field: string, value: any) => void;
  removeDateRange: (index: number) => void;
  addDateRange: () => void;
  pricingOptions: PricingModel[];
  handlePricingOptionChange: (pricingIndex: number, field: string, value: any) => void;
  removePricingOption: (pricingIndex: number) => void;
  addPricingOption: () => void;
}

const PricingOptions: React.FC<Props> = ({
  dateRanges,
  handleDateRangeChange,
  removeDateRange,
  addDateRange,
  pricingOptions,
  handlePricingOptionChange,
  removePricingOption,
  addPricingOption,
}) => {
  
  return (
    <section className="pricing-options-section">
      <h3>Date Ranges</h3>
      {dateRanges.map((range: any, dateRangeIndex: number) => (
        <div key={dateRangeIndex} className="date-range">
          <label htmlFor={`startDate-${dateRangeIndex}`}>Start Date</label>
          <input
            type="date"
            id={`startDate-${dateRangeIndex}`}
            value={format(range.startDate, 'yyyy-MM-dd')}
            onChange={(e) =>
              handleDateRangeChange(
                dateRangeIndex,
                "startDate",
                parseISO(e.target.value)
              )
            }
          />
          <label htmlFor={`endDate-${dateRangeIndex}`}>End Date</label>
          <input
            type="date"
            id={`endDate-${dateRangeIndex}`}
            value={format(range.endDate, 'yyyy-MM-dd')}
            onChange={(e) =>
              handleDateRangeChange(dateRangeIndex, "endDate", parseISO(e.target.value))
            }
          />
          <button className='mx-3' type="button" onClick={() => removeDateRange(dateRangeIndex)}>
            Remove Date Range
          </button>
        </div>
      ))}
      <button type="button" onClick={addDateRange}>
        Add Date Range
      </button>

      <h3 className='mt-2 pt-2'>Pricing Options</h3>
      <div className="grid-header">
        <div className="grid-item">Description</div>
        <div className="grid-item">Price</div>
        <div className="grid-item">Min Persons</div>
        <div className="grid-item">Max Persons</div>
        <div className="grid-item">Discount</div>
        <div className="grid-item">Actions</div>
      </div>
      {pricingOptions.map((option: PricingModel, pricingIndex: number) => (
        <div key={pricingIndex} className="grid-row">
          <div className="grid-item">
            <input
              type="text"
              placeholder="Description"
              value={option.description || ""}
              onChange={(e) =>
                handlePricingOptionChange(pricingIndex, "description", e.target.value)
              }
            />
          </div>
          <div className="grid-item">
            <input
              type="number"
              id={`price-${pricingIndex}`}
              placeholder="Price"
              value={option.price !== undefined ? option.price : ""}
              onChange={(e) =>
                handlePricingOptionChange(
                  pricingIndex,
                  "price",
                  parseFloat(e.target.value)
                )
              }
            />
          </div>
          <div className="grid-item">
            <input
              type="number"
              id={`minPersons-${pricingIndex}`}
              placeholder="Min Persons"
              value={option.minPersons !== undefined ? option.minPersons : ""}
              onChange={(e) =>
                handlePricingOptionChange(
                  pricingIndex,
                  "minPersons",
                  parseInt(e.target.value, 10)
                )
              }
            />
          </div>
          <div className="grid-item">
            <input
              type="number"
              id={`maxPersons-${pricingIndex}`}
              placeholder="Max Persons"
              value={option.maxPersons !== undefined ? option.maxPersons : ""}
              onChange={(e) =>
                handlePricingOptionChange(
                  pricingIndex,
                  "maxPersons",
                  parseInt(e.target.value, 10)
                )
              }
            />
          </div>
          <div className="grid-item">
            <input
              type="number"
              id={`discount-${pricingIndex}`}
              placeholder="Discount"
              value={option.discount !== undefined ? option.discount : ""}
              onChange={(e) =>
                handlePricingOptionChange(
                  pricingIndex,
                  "discount",
                  parseInt(e.target.value, 10)
                )
              }
            />
          </div>
          <div className="grid-item">
            <button type="button" onClick={() => removePricingOption(pricingIndex)}>
              Remove
            </button>
          </div>
        </div>
      ))}
      <button type="button" onClick={addPricingOption}>
        Add Pricing Option
      </button>
    </section>
  );
};

export default PricingOptions;